import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const DatePickerWrapper = styled.div`
    .react-datepicker-popper {
        z-index: 99;
    }
`
export const TimelineWrapper = styled.div`
    height: 100%;
    // padding: 15px;

    .rct-header-root {
        background-color: #fff !important;
    }
    .rct-calendar-header {
        .rct-dateHeader {
            background-color: #dddee1 !important;
        }
    }
    .rct-vertical-lines {
        display: none;
    }

    .row-aux {
        background: rgba(0, 155, 183, 0.1) !important;
    }

    .rct-horizontal-lines {
        .rct-hl-even,
        .rct-hl-odd {
            //horizontal lines
            background-color: #f5f5f5;
        }
    }

    .rct-scroll {
        overflow-x: hidden; //fix unwanted horizontal scroll
    }

    .rct-sidebar-right {
        width: 100px !important;
        margin-left: -100px;
        text-align: right;
        border: unset !important;

        .rct-sidebar-row-even,
        .rct-sidebar-row-odd {
            //horizontal lines
            background: transparent !important;
            //border-right: 3px solid red;
        }

        div:first-child {
            width: 100px !important;
        }
    }

    /* .rct-item {
        height: 15px !important;
        line-height: 15px !important;
    } */
`

export const GanttWrapper = styled.div``

export const GanttHeader = styled.div`
    display: flex;
    font-weight: normal;
    font-size: 13px;
    // padding: 5px 5px;
    z-index: 91;
    max-height: 33px;
    position: relative;
    background: white;

    .form-group {
        margin-left: 5px;
        margin-bottom: 0px;
        width: 54px;
        margin-top: 1px;
    }
    .Select-menu-outer {
        width: 100px;
    }
    .Select-control {
        background-color: ${theme['gray-lighter']} !important;
        border: 0px;
        height: 30px;
    }
    .Select-input {
        height: 30px;
        background-color: ${theme['gray-lighter']} !important;
    }
    .Select-option {
        background-color: ${theme['gray-lighter']};
    }
`

export const EditGanttSection = styled.div`
    padding: 2px 5px;
`

export const ZoomIcons = styled.div`
    padding: 5px 10px;
    display: flex;

    .plus {
        margin-right: 5px;
    }
    .minus {
        margin-right: 5px;
    }
    .Select-placeholder {
        height: 23px;
        line-height: 23px;
    }
    .Select-input {
        height: 23px;
    }
    .Select-control {
        height: 23px;
    }
    .Select-value {
        line-height: 23px !important;
    }
    .form-group {
        margin-left: 0px;
        margin-right: 5px;
        width: 100px;
    }
`

export const MouseGanttLink = styled.div`
    svg {
        z-index: 90;
    }
`
export const AddLinkButton = styled.div`
    font-weight: 900;
    font-size: 9px;
    line-height: 16px;
    color: #008ac7;
`
export const AddLinkButtonLeft = styled(AddLinkButton)`
    margin-left: -15px;
    margin-top: -1px;
    width: 1px;
    padding-right: 15px;
`
export const AddLinkButtonRight = styled(AddLinkButton)`
    margin-right: -5px;
    margin-top: -15px;
    padding-left: 15px;
    text-align: right;
    width: 1px;
    float: right;
`
export const SelectLinkButtonLeft = styled(AddLinkButtonLeft)`
    .linkIcons:hover .icon-not-selected,
    .linkIcons .icon-selected {
        display: none;
    }
    .linkIcons:hover .icon-selected {
        display: inline;
    }
`
export const SelectLinkButtonRight = styled(AddLinkButtonRight)`
    margin-top: 0px;
    .linkIcons:hover .icon-not-selected,
    .linkIcons .icon-selected {
        display: none;
    }
    .linkIcons:hover .icon-selected {
        display: inline;
    }
`
export const MiniModalArrow = styled.div`
    width: 0;
    height: 0;
    border-left: '5px solid transparent';
    border-right: '5px solid transparent';
    border-bottom: '5px solid rgba(0, 0, 0, 0.15)';
`
export const MiniModal = styled.div`
    width: 97px;
    height: 17px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    font-weight: 900;
    font-size: 9px;
    line-height: 16px;
    margin-left: -40px;
    color: #868695;
`
export const SingleMiniModal = styled(MiniModal)`
    display: flex;
    width: 200px;
    align-items: center;
`
export const SelectorModalLeft = styled.div`
    width: 84px;
    height: 40px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    font-weight: 900;
    font-size: 9px;
    line-height: 16px;
    color: #37a3ef;
    margin-left: -110px;
    padding: 3px;
    i {
        padding-right: 2px;
    }
`
export const SelectorModalRight = styled.div`
    width: 84px;
    height: 40px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    font-weight: 900;
    font-size: 9px;
    line-height: 16px;
    color: #37a3ef;
    margin-right: -110px;
    float: right;
    padding: 3px;
    i {
        padding-right: 2px;
    }
`
export const ConfirmationButtons = styled.div<{ isConfirm: string }>`
    float: ${({ isConfirm }) => (isConfirm === 'right' && 'right') || (isConfirm === 'move' && undefined) || 'left'};
    margin-right: ${({ isConfirm }) => (isConfirm === 'right' && '-16px') || '0px'};
    text-align: ${({ isConfirm }) => (isConfirm === 'move' && 'center') || undefined};

    div {
        cursor: pointer;
    }
`
export const ConfirmationIcon = styled.div<{ type: string }>`
    margin-top: 16px;
    color: ${({ type }) => (type === 'confirm' && 'blue') || 'red'};
    margin-left: ${({ type }) => (type === 'confirm' && '-15px') || '0px'};
    margin-right: ${({ type }) => (type === 'confirm' && '15px') || '0px'};
`
export const ArrowAux = styled.div<{ selected: boolean }>`
    margin-top: ${({ selected }) => (!selected && '0px') || '18px'};
    margin-bottom: ${({ selected }) => (selected && '-18px') || '0px'};
    position: relative;
    margin-right: 1px;
    width: 1px;
    float: right;
    height: 1px;
`
export const DerrickGanttSider = styled.div<{ color: string }>`
    border-right: ${({ color }) => '7px solid' + color};
    text-overflow: ellipsis;
    overflow: hidden;
    z-index: 80;
    padding-top: 10px;
    padding-right: 2px;
    position: relative;
    font-size: 9px;
    font-weight: 600;
`

export const ResizeArea = styled.div<{ left?: boolean; right?: boolean }>`
    position: absolute;
    width: 10%;
    cursor: col-resize !important;
    ${({ right }) => {
        return (
            right &&
            css`
                right: 0;
            `
        )
    }}
    ${({ left }) => {
        return (
            left &&
            css`
                left: 0;
            `
        )
    }};
`
